export default "__VITE_ASSET__ByULjr01__"